import "./announced.css";

export const Announced = () => {
  return (
    <div className="container">
      Добро пожаловать в первый магазин-прокат туристического снаряжения Аджарии
    </div>
  );
};
